import React, { useEffect, useState } from 'react';
import { Outlet, NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LayoutDashboard, Database, Users, Megaphone, MessageSquare, BarChart3, Settings, LogOut, Menu, X } from 'lucide-react';
import api from '../utils/api';

const navItems = [
  { to: '/', icon: LayoutDashboard, label: 'Dashboard', end: true },
  { to: '/datasets', icon: Database, label: 'Mis Bases' },
  { to: '/leads', icon: Users, label: 'Todos los Leads' },
  { to: '/campaigns', icon: Megaphone, label: 'Campañas' },
  { to: '/templates', icon: MessageSquare, label: 'Plantillas' },
  { to: '/reports', icon: BarChart3, label: 'Reportes' },
  { to: '/settings', icon: Settings, label: 'Configuración', adminOnly: true },
];

export default function Layout() {
  const { logout, user, tenant } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [clientName, setClientName] = useState('');

  useEffect(() => {
    if (tenant?.company_name) { setClientName(tenant.company_name); }
    else { api.get('/settings').then(res => setClientName(res.data.client_name || '')).catch(() => {}); }
  }, [tenant]);

  const logoSrc = tenant?.logo_url || '/logoudream.png';
  const crmTitle = tenant?.company_name ? `${tenant.company_name.toUpperCase()} APP` : 'UDREAM APP';

  return (
    <div style={{ display:'flex', height:'100vh', overflow:'hidden' }}>
      <button onClick={() => setMobileOpen(!mobileOpen)} className="mobile-menu-btn"
        style={{ position:'fixed', top:12, left:12, zIndex:1001, background:'var(--bg-card)', border:'1px solid var(--border)', borderRadius:8, padding:8, color:'var(--text-primary)', display:'none' }}>
        {mobileOpen ? <X size={20}/> : <Menu size={20}/>}
      </button>
      {mobileOpen && <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',zIndex:998}} onClick={()=>setMobileOpen(false)}/>}
      <aside className="sidebar" style={{ width:250, minWidth:250, height:'100vh', background:'var(--bg-secondary)', borderRight:'1px solid var(--border)', display:'flex', flexDirection:'column', position: mobileOpen ? 'fixed' : 'relative', zIndex:999 }}>
        <div style={{ padding:'24px 20px', borderBottom:'1px solid var(--border)' }}>
          <img src={logoSrc} alt="Logo" style={{ height:44, marginBottom:6 }} onError={e => { e.target.style.display='none'; }} />
          <div style={{ fontSize:14, fontWeight:800, color:'var(--text-primary)', letterSpacing:1, marginTop:6 }}>{crmTitle}</div>
          {clientName && <div style={{ fontSize:11, color:'var(--text-muted)', fontWeight:500, marginTop:2 }}>{clientName}</div>}
        </div>
        <nav style={{ flex:1, padding:'12px 10px', display:'flex', flexDirection:'column', gap:2, overflowY:'auto' }}>
          {navItems.filter(item => {
            if (item.adminOnly && user?.role === 'client') return false;
            const hidden = tenant?.features?.hidden_modules || [];
            if (item.to === '/campaigns' && hidden.includes('campaigns')) return false;
            if (item.to === '/templates' && hidden.includes('templates')) return false;
            if (item.to === '/reports' && hidden.includes('reports')) return false;
            return true;
          }).map(item => (
            <NavLink key={item.to} to={item.to} end={item.end} onClick={() => setMobileOpen(false)}
              style={({ isActive }) => ({ display:'flex', alignItems:'center', gap:12, padding:'10px 14px', borderRadius:10, fontSize:14, fontWeight: isActive ? 600 : 500, color: isActive ? '#fff' : 'var(--text-secondary)', background: isActive ? 'var(--accent)' : 'transparent', textDecoration:'none', transition:'all 0.15s' })}>
              <item.icon size={18}/> {item.label}
            </NavLink>
          ))}
        </nav>
        <div style={{ padding:'16px', borderTop:'1px solid var(--border)' }}>
          <div style={{ fontSize:13, color:'var(--text-secondary)', marginBottom:8 }}>{user?.display_name || user?.username}</div>
          <button onClick={logout} className="btn btn-ghost" style={{ width:'100%', justifyContent:'flex-start', gap:8 }}><LogOut size={16}/> Cerrar sesión</button>
        </div>
      </aside>
      <main style={{ flex:1, overflow:'auto', padding:28 }}><Outlet/></main>
      <style>{`
        @media (max-width: 768px) {
          .sidebar { position: fixed !important; transform: translateX(${mobileOpen ? '0' : '-100%'}) !important; transition: transform 0.25s; }
          .mobile-menu-btn { display: block !important; }
          main { padding: 16px !important; padding-top: 56px !important; }
          .sidebar > div:first-child { padding-top: 56px !important; }
        }
      `}</style>
    </div>
  );
}
